<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">

          <div v-if="!isGeneralLoading && form.Modulos.length === 0">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{msgEmptyModules}}</label>
          </div>

          <base-collapsible-form 
            v-for="(cabecera, index) in form.Modulos"
            :key="index"
            :ref="'baseCollapsibleModules'+index" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{cabecera.Descripcion}}</h4>
            </template>
            <template slot="content">
              <div class="mb-4" 
                v-for="modulo in cabecera.Modulos"
                :key="modulo.idModulo">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{modulo.Descripcion}}</label>
                <div class="flex flex-col md:flex-row">
                  <el-switch 
                    class="switch-text break-normal both-switch" 
                    v-model="modulo.Contratado" 
                    :active-text="$t('app.active')" 
                    />
                  <label class="text-sm font-semibold dark:text-secondary-600 text-secondary-300 block mb-1 ml-0 md:ml-4">{{modulo.FechaCambioEstado}}</label>
                </div>
              </div>

            </template>
          </base-collapsible-form>
        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm()" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import { getDistributor } from '@/services/distributors/getDistributor'
import { updateModulos } from '@/services/distributors/updateModulos'
import { getModulos } from '@/services/distributors/getModulos'
import { i18n } from '@/i18n'
import { bus } from '@/main'

export default {
  /* eslint-disable camelcase */
  name: 'modules-distributor-detail',
  components: {
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('clients.modules'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/distributors/details'
      },
      msgEmptyModules: i18n.t('clients.modules_empty'),
      msgEmptyDate: i18n.t('clients.modules_empty_date'),
      form: {
        Modulos: [],
      },
      rules: {}
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    modulos: function () {
      return this.$store.getters['config/MODULOS']
    },
    cabecerasModulos: function () {
      return this.$store.getters['config/CABECERAS_MODULOS']
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    }
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: 'configurationssa',
        name: i18n.t('configurations.header')
      })
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: i18n.t('distributors.header')
      })
      const distributor = await this.downloadDistributorData(this.id)
      breadcrumbs.push({ path: '', name: distributor.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', distributor.Nombre)
      this.disableRoutes(distributor.idTipoProvisionamiento)
    }
    this.header.breadcrumb = breadcrumbs

    const data = await this.downloadData(this.id)
    this.setData(data.Cabeceras)
  },
  methods: {
    disableRoutes: function () {
      const objDisableRoutes = {
        disableModules: this.form.TipoProvisionamiento === 1,
        disableLocations: this.form.TipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    formatDate: function (strDate) {
      return i18n.d(strDate, 'numeric_datetime', { date: '-', datetime: ' ' })
    },
    downloadDistributorData: async function (id) {
      let distribuidor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        const response = await getDistributor(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
        distribuidor = response.distribuidor
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distribuidor
    },
    submitForm: async function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const modulos = []
        this.form.Modulos.forEach(cabecera => {
          cabecera.Modulos.forEach(modulo => {
            modulos.push({
              idModulo: modulo.idModulo,
              Activo: modulo.Contratado,
            })
          })
        })
        const payload = {
          idDistribuidor: this.$route.params.id,
          Modulos: modulos,
        }
        const response = await updateModulos(null, payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.updated_data_msg'), 'success')
          const data = await this.downloadData(this.$route.params.id)
          this.setData(data.Modulos)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/distributors/details', params: this.$route.params.id })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const data = await getModulos({ idDistribuidor: id })
        if (data.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          return data
        }
        return data
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setData: function (data) {
      if (data) {
        const cabeceras = data
        cabeceras.forEach(cabecera => {
          cabecera.Descripcion = this.getHeaderName(cabecera)
          cabecera.Modulos.forEach(x => {
            x.Descripcion = this.getModuleName(x)
            if (x.FechaCambioEstado) x.FechaCambioEstado = this.formatDate(x.FechaCambioEstado)
            else x.FechaCambioEstado = this.msgEmptyDate
          })
        })
        this.form.Modulos = cabeceras
      }
    },
    getModuleName: function (modulo) {
      const module = this.modulos.find(x => x.id === modulo.idModulo)
      if (module) {
        return module.Nombre
      }
      console.warn(i18n.t('feedback.warning.unrecognized_module_warn', { module: modulo.idModulo }))
      return modulo.idModulo
    },
    getHeaderName: function (cabecera) {
      const header = this.cabecerasModulos.find(x => x.id === cabecera.idCabecera)
      if (header) {
        return header.Nombre
      }
      console.warn(i18n.t('feedback.warning.unrecognized_module_header_warn', { header: cabecera.idCabecera }))
      return cabecera.idCabecera
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
